import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initSentry, initAuth } from '@trinity/utils'
import './styles/style.css'

const sentryDsn = 'https://5512adf702514bdba4aac2d3b2535514@o170893.ingest.us.sentry.io/4511773825761280'
const sentryRelease = `admin@${__APP_VERSION__}`
initSentry(sentryDsn, sentryRelease)

initAuth()

React.startTransition(() => {
  hydrateRoot(
    document,
    <React.StrictMode>
      <HydratedRouter />
    </React.StrictMode>,
  )
})
